// MARK://dhk8/pos/lib/clients/users
// Lightweight read-only adapter para resolver `userId → displayName` cuando el
// POS necesita pintar nombres (p. ej. "Atendió: …" en el preview del ticket).
// F6.2 R3d / ADR-0009: read por el grafo (platform-auth `staffUser(id)`, tenant
// del JWT vía el header `x-dhk8-tenant-id` que inyecta gqlClient). Reemplaza el
// GET REST /api/users/:id. Devuelve { id, fullName, email, role }.
//
// Decisión: best-effort — devuelve `null` ante 404 / auth / red para que el
// preview del ticket nunca falle por un lookup de usuario (cae a "Cajero").
import { gqlClient } from '../gql.js'
import { PosStaffUserQuery } from '../queries/users.queries.js'

export interface PosUserBrief {
  id: string
  fullName: string
  email: string | null
  role: string | null
}

/**
 * Resolve a user id to a display brief. Returns `null` on not-found or any auth /
 * network failure — the caller falls back to a generic label ("Cajero").
 */
export async function getUserById(id: string, signal?: AbortSignal): Promise<PosUserBrief | null> {
  if (!id) return null
  try {
    const ctx = signal ? { fetchOptions: { signal } } : undefined
    const res = await gqlClient.query(PosStaffUserQuery, { id }, ctx).toPromise()
    if (res.error) return null
    const u = res.data?.staffUser
    if (!u) return null
    return {
      id: u.id,
      fullName: (u.fullName ?? '').trim() || (u.email ?? '').trim() || u.id,
      email: u.email ?? null,
      role: u.role ?? null,
    }
  } catch {
    return null
  }
}
